import React from "react"
import _ from "lodash"

import ConfirmationModal from "components/modal/confirmation-modal"

export type ICalcModal = {
  calcConfirmVisible: boolean
  propsWithErrors: Array<{}>
  propsWithSevereErrors: Array<{}>
  propsRequiringMigration: Array<{}>
  onConfirmCalc: Function
  onCancelCalc: Function
  toggleModalVisible: Function
}

const CalcModal = (props: ICalcModal) => {
  return (
    <ConfirmationModal
      show={props.calcConfirmVisible}
      toggleShow={props.onCancelCalc}
      title={'Folder Calc Validation Warning'}
      confirmText={'Ignore'}
      message={
        props.propsWithSevereErrors.length ?
          `There are properties in this folder with critical input errors that must be corrected before a calculation is allowed.` :
          `There are properties in this folder which have input errors that may result in incomplete or invalid calculations.
          Are you sure you want to ignore this warning and calculate all properties before correcting the errors?`
      }
      confirmFunc={props.onConfirmCalc}
      cancelFunc={props.onCancelCalc}
      confirmOnly={false}
      closeOnly={props.propsWithSevereErrors.length !== 0 || props.propsRequiringMigration.length !== 0}>
      {props.propsWithSevereErrors.length ?
        <div>
          <div>The following uncalculated properties in this folder have severe input errors which must be corrected:</div>
          <ul className="list-style-circle margin-left-lg margin-top-sm">
            {props.propsWithSevereErrors && props.propsWithSevereErrors.map((prop, i) => {
              return <li key={i}>{_.get(prop, "code")}</li>;
            })}
          </ul>
        </div> : null
      }
      {props.propsWithErrors.length ?
        <div>
          <div>The following uncalculated properties in this folder have input errors:</div>
          <ul className="list-style-circle margin-left-lg margin-top-sm">
            {props.propsWithErrors && props.propsWithErrors.map((prop, i) => {
              return <li key={i}>{_.get(prop, "code")}</li>;
            })}
          </ul>
        </div> : null
      }
      {props.propsRequiringMigration.length ?
        <div>
          <div>The following properties in this folder require upgrade:</div>
          <ul className="list-style-circle margin-left-lg margin-top-sm">
            {props.propsRequiringMigration && props.propsRequiringMigration.map((prop, i) => {
              return <li key={i}>{_.get(prop, "code")}</li>;
            })}
          </ul>
        </div> : null
      }
    </ConfirmationModal>
  )
}

export default CalcModal
